(function () {
  var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
  var ZOOM_STEP = 1.25;
  var MAX_ZOOM_MULTIPLIER = 6;
  var SCALE_EPSILON = 0.0001;
  var DIRECTORY_PAGE_URL = '/pages/show-directory-july-2026';
  var MIN_LABEL_FONT_SIZE = 10;
  var MAX_LABEL_FONT_SIZE = 110;
  var LABEL_VISIBILITY_THRESHOLDS = {
    desktop: 6.5,
    tablet: 5,
    mobile: 3.75
  };
  var MAP_LABEL_OVERRIDES = {
    '811': {
      primaryName: 'TIMING',
      displayLines: ['TIMING', 'LUMIÈRE'],
      lineGapAfter: [0]
    },
    '1103': { primaryName: 'Blu Pepper' },
    '1203': {
      primaryName: 'Koastal Konnection',
      displayLines: ['Koastal', 'Konnection', 'Koast by', 'Koastal'],
      lineGapAfter: [1]
    },
    '1300': { primaryName: 'Very J' },
    '1511': { primaryName: 'Angie' },
    '1601': {
      displayLines: ['Like', 'Dreams'],
      fontSizeMultiplier: 1.2
    }
  };

  function cleanString(value) {
    return typeof value === 'string' ? value.trim() : '';
  }

  function normalizeList(value) {
    var values = Array.isArray(value) ? value : cleanString(value).split(',');
    var seen = {};

    return values.map(cleanString).filter(function (item) {
      var key = item.toLocaleLowerCase();

      if (!item || seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }

  function normalizeRecord(record, index) {
    var active = record.active;

    return {
      id: cleanString(record.id) || 'floor-map-record-' + index,
      name: cleanString(record.name),
      recordType: cleanString(record.record_type).toLocaleLowerCase(),
      booth: cleanString(record.booth),
      representedBy: cleanString(record.represented_by),
      brandsRepresented: normalizeList(record.brands_represented),
      categories: normalizeList(record.categories),
      website: cleanString(record.website),
      instagram: cleanString(record.instagram),
      active: active === undefined || active === null || active === '' || active === true || active === 1 || String(active).toLocaleLowerCase() === 'true'
    };
  }

  function compareByName(first, second) {
    return first.name.localeCompare(second.name, undefined, { sensitivity: 'base' });
  }

  function uniqueStrings(values) {
    var seen = {};

    return values.filter(function (value) {
      var key = value.toLocaleLowerCase();

      if (!value || seen[key]) return false;
      seen[key] = true;
      return true;
    }).sort(function (first, second) {
      return first.localeCompare(second, undefined, { sensitivity: 'base' });
    });
  }

  function buildBoothIndex(records) {
    var activeRecords = records.filter(function (record) { return record.active && record.name; });
    var showroomsByName = {};
    var booths = {};
    var representedResolved = 0;
    var unresolvedRepresented = [];
    var categories;
    var categoryBooths = {};

    activeRecords.filter(function (record) {
      return record.recordType === 'showroom';
    }).forEach(function (record) {
      showroomsByName[record.name.toLocaleLowerCase()] = record;
    });

    activeRecords.forEach(function (record) {
      var resolvedBooth = record.booth;
      var parentShowroom = null;

      if (record.recordType === 'represented_brand') {
        parentShowroom = showroomsByName[record.representedBy.toLocaleLowerCase()] || null;
        if (parentShowroom && parentShowroom.booth) {
          resolvedBooth = parentShowroom.booth;
          representedResolved += 1;
        } else {
          unresolvedRepresented.push(record);
        }
      }

      if (!resolvedBooth) return;
      record.resolvedBooth = resolvedBooth;
      record.parentShowroom = parentShowroom;
      if (!booths[resolvedBooth]) booths[resolvedBooth] = { booth: resolvedBooth, records: [] };
      booths[resolvedBooth].records.push(record);
    });

    Object.keys(booths).forEach(function (boothNumber) {
      var booth = booths[boothNumber];
      var override = MAP_LABEL_OVERRIDES[boothNumber] || {};
      var primaryCandidates;

      booth.showrooms = booth.records.filter(function (record) { return record.recordType === 'showroom'; }).sort(compareByName);
      booth.directBrands = booth.records.filter(function (record) { return record.recordType === 'brand'; }).sort(compareByName);
      booth.representedBrands = booth.records.filter(function (record) { return record.recordType === 'represented_brand'; }).sort(compareByName);
      booth.categories = uniqueStrings([].concat.apply([], booth.records.map(function (record) { return record.categories; })));
      booth.ambiguous = false;
      booth.ambiguityReason = '';

      if (booth.showrooms.length) {
        primaryCandidates = booth.showrooms;
        if (booth.showrooms.length > 1) {
          booth.ambiguous = true;
          booth.ambiguityReason = 'multiple showrooms';
        }
      } else if (booth.directBrands.length) {
        primaryCandidates = booth.directBrands;
        if (booth.directBrands.length > 1) {
          booth.ambiguous = true;
          booth.ambiguityReason = 'multiple direct brands';
        }
      } else {
        primaryCandidates = booth.representedBrands;
        booth.ambiguous = true;
        booth.ambiguityReason = 'represented brands without a direct brand or showroom';
      }

      booth.primary = primaryCandidates[0] || null;
      if (override.primaryName) {
        booth.primary = booth.showrooms.concat(booth.directBrands).filter(function (record) {
          return record.name.toLocaleLowerCase() === override.primaryName.toLocaleLowerCase();
        })[0] || booth.primary;
      }
      booth.mapLabel = cleanString(override.displayName) || (booth.primary ? booth.primary.name : '');
    });

    categories = uniqueStrings([].concat.apply([], Object.keys(booths).map(function (boothNumber) {
      return booths[boothNumber].categories;
    })));
    categories.forEach(function (category) {
      categoryBooths[category] = Object.keys(booths).filter(function (boothNumber) {
        return booths[boothNumber].categories.some(function (boothCategory) {
          return boothCategory.toLocaleLowerCase() === category.toLocaleLowerCase();
        });
      }).sort(function (first, second) { return Number(first) - Number(second); });
    });

    return {
      records: activeRecords,
      booths: booths,
      categories: categories,
      categoryBooths: categoryBooths,
      representedResolved: representedResolved,
      unresolvedRepresented: unresolvedRepresented,
      ambiguousBooths: Object.keys(booths).map(function (key) { return booths[key]; }).filter(function (booth) { return booth.ambiguous; })
    };
  }

  function numberFromText(textElement) {
    var value = String(textElement.textContent || '').replace(/\s+/g, '');
    return /^\d+$/.test(value) ? value : '';
  }

  function transformedPoint(element, x, y) {
    var svg = element.ownerSVGElement;
    var point = svg.createSVGPoint();
    var matrix = element.getCTM();

    point.x = x;
    point.y = y;

    return matrix ? point.matrixTransform(matrix) : point;
  }

  function rootSvgPoint(element, x, y) {
    var svg = element.ownerSVGElement;
    var point = svg.createSVGPoint();
    var elementMatrix = element.getCTM();
    var svgMatrix = svg.getCTM();
    var matrix = elementMatrix && svgMatrix ? svgMatrix.inverse().multiply(elementMatrix) : elementMatrix;

    point.x = x;
    point.y = y;

    return matrix ? point.matrixTransform(matrix) : point;
  }

  function rectangleBounds(rectangle) {
    var x = rectangle.x.baseVal.value;
    var y = rectangle.y.baseVal.value;
    var width = rectangle.width.baseVal.value;
    var height = rectangle.height.baseVal.value;
    var points = [
      transformedPoint(rectangle, x, y),
      transformedPoint(rectangle, x + width, y),
      transformedPoint(rectangle, x, y + height),
      transformedPoint(rectangle, x + width, y + height)
    ];

    return {
      minX: Math.min.apply(null, points.map(function (point) { return point.x; })),
      maxX: Math.max.apply(null, points.map(function (point) { return point.x; })),
      minY: Math.min.apply(null, points.map(function (point) { return point.y; })),
      maxY: Math.max.apply(null, points.map(function (point) { return point.y; }))
    };
  }

  function squaredDistanceToBounds(point, bounds) {
    var deltaX = point.x < bounds.minX
      ? bounds.minX - point.x
      : point.x > bounds.maxX ? point.x - bounds.maxX : 0;
    var deltaY = point.y < bounds.minY
      ? bounds.minY - point.y
      : point.y > bounds.maxY ? point.y - bounds.maxY : 0;

    return (deltaX * deltaX) + (deltaY * deltaY);
  }

  function matchBooths(svg) {
    var rectangles = Array.prototype.slice.call(svg.querySelectorAll('rect'));
    var labels = Array.prototype.slice.call(svg.querySelectorAll('text')).map(function (textElement) {
      return {
        booth: numberFromText(textElement),
        element: textElement,
        point: transformedPoint(textElement, 0, 0)
      };
    }).filter(function (label) {
      return label.booth;
    });
    var rectangleEntries = rectangles.map(function (rectangle) {
      return { element: rectangle, bounds: rectangleBounds(rectangle) };
    });
    var usedRectangles = [];
    var usedBooths = [];
    var rectanglesByBooth = {};

    if (!rectangles.length || rectangles.length !== labels.length) {
      throw new Error('Floor map booth matching requires equal non-zero rectangle and booth-number counts.');
    }

    labels.forEach(function (label) {
      var candidates = rectangleEntries.slice().sort(function (first, second) {
        return squaredDistanceToBounds(label.point, first.bounds) - squaredDistanceToBounds(label.point, second.bounds);
      });
      var rectangle = candidates[0].element;

      if (usedRectangles.indexOf(rectangle) !== -1 || usedBooths.indexOf(label.booth) !== -1) {
        throw new Error('Floor map booth matching did not produce a one-to-one result for booth ' + label.booth + '.');
      }

      usedRectangles.push(rectangle);
      usedBooths.push(label.booth);
      rectanglesByBooth[label.booth] = rectangle;
      rectangle.setAttribute('data-booth', label.booth);
      rectangle.setAttribute('role', 'button');
      rectangle.setAttribute('tabindex', '0');
      rectangle.setAttribute('focusable', 'true');
      rectangle.setAttribute('aria-label', 'Select booth ' + label.booth);
      rectangle.setAttribute('aria-pressed', 'false');
      label.element.setAttribute('data-booth-number', label.booth);
      label.element.setAttribute('aria-hidden', 'true');
      label.element.style.pointerEvents = 'none';
    });

    if (usedRectangles.length !== rectangles.length) {
      throw new Error('Not every floor map rectangle was assigned a booth number.');
    }

    return {
      count: usedRectangles.length,
      rectanglesByBooth: rectanglesByBooth
    };
  }

  function createViewport(svg) {
    var viewport = document.createElementNS(SVG_NAMESPACE, 'g');
    var children = Array.prototype.slice.call(svg.children).filter(function (child) {
      return child.tagName.toLowerCase() !== 'title';
    });

    viewport.setAttribute('data-map-viewport', '');
    children.forEach(function (child) {
      viewport.appendChild(child);
    });
    svg.appendChild(viewport);

    return viewport;
  }

  function wordsToLines(name, maximumCharacters, maximumLines) {
    var words = name.split(/\s+/);
    var lines = [];
    var current = '';

    words.forEach(function (word) {
      var candidate = current ? current + ' ' + word : word;

      if (current && candidate.length > maximumCharacters && lines.length < maximumLines - 1) {
        lines.push(current);
        current = word;
      } else {
        current = candidate;
      }
    });

    if (current) lines.push(current);
    return lines;
  }

  function measuredLineCandidates(name, maximumLines) {
    var words = name.split(/\s+/).filter(Boolean);
    var candidates = [];

    function addCandidates(lineCount, startIndex, lines) {
      var remainingLines = lineCount - lines.length;
      var maximumEnd = words.length - remainingLines + 2;
      var endIndex;

      if (remainingLines === 1) {
        candidates.push(lines.concat(words.slice(startIndex).join(' ')));
        return;
      }

      for (endIndex = startIndex + 1; endIndex < maximumEnd; endIndex += 1) {
        addCandidates(lineCount, endIndex, lines.concat(words.slice(startIndex, endIndex).join(' ')));
      }
    }

    if (!words.length) return [];
    for (var lineCount = 1; lineCount <= Math.min(maximumLines, words.length); lineCount += 1) {
      addCandidates(lineCount, 0, []);
    }
    return candidates;
  }

  function elementBounds(element) {
    var box = element.getBBox();
    var points = [
      rootSvgPoint(element, box.x, box.y),
      rootSvgPoint(element, box.x + box.width, box.y),
      rootSvgPoint(element, box.x + box.width, box.y + box.height),
      rootSvgPoint(element, box.x, box.y + box.height)
    ];

    return {
      minX: Math.min.apply(null, points.map(function (point) { return point.x; })),
      maxX: Math.max.apply(null, points.map(function (point) { return point.x; })),
      minY: Math.min.apply(null, points.map(function (point) { return point.y; })),
      maxY: Math.max.apply(null, points.map(function (point) { return point.y; }))
    };
  }

  function rectangleGeometry(rectangle) {
    var x = rectangle.x.baseVal.value;
    var y = rectangle.y.baseVal.value;
    var width = rectangle.width.baseVal.value;
    var height = rectangle.height.baseVal.value;
    var points = [
      rootSvgPoint(rectangle, x, y),
      rootSvgPoint(rectangle, x + width, y),
      rootSvgPoint(rectangle, x + width, y + height),
      rootSvgPoint(rectangle, x, y + height)
    ];

    return {
      points: points,
      minX: Math.min.apply(null, points.map(function (point) { return point.x; })),
      maxX: Math.max.apply(null, points.map(function (point) { return point.x; })),
      minY: Math.min.apply(null, points.map(function (point) { return point.y; })),
      maxY: Math.max.apply(null, points.map(function (point) { return point.y; }))
    };
  }

  function combinedBoothBounds(rectanglesByBooth) {
    var geometries = Object.keys(rectanglesByBooth).map(function (boothNumber) {
      return rectangleGeometry(rectanglesByBooth[boothNumber]);
    });
    var minX = Math.min.apply(null, geometries.map(function (geometry) { return geometry.minX; }));
    var maxX = Math.max.apply(null, geometries.map(function (geometry) { return geometry.maxX; }));
    var minY = Math.min.apply(null, geometries.map(function (geometry) { return geometry.minY; }));
    var maxY = Math.max.apply(null, geometries.map(function (geometry) { return geometry.maxY; }));

    return {
      x: minX,
      y: minY,
      width: maxX - minX,
      height: maxY - minY
    };
  }

  function responsiveFitPadding() {
    if (window.innerWidth < 750) return 0.015;
    if (window.innerWidth < 990) return 0.025;
    return 0.045;
  }

  function setEffectiveViewBox(svg, boothBounds) {
    var padding = responsiveFitPadding();
    var horizontalPadding = boothBounds.width * padding;
    var verticalPadding = boothBounds.height * padding;
    var effective = {
      x: boothBounds.x - horizontalPadding,
      y: boothBounds.y - verticalPadding,
      width: boothBounds.width + (horizontalPadding * 2),
      height: boothBounds.height + (verticalPadding * 2)
    };

    svg.setAttribute('viewBox', [effective.x, effective.y, effective.width, effective.height].join(' '));
    return effective;
  }

  function pointInsidePolygon(point, polygon) {
    var inside = false;
    var previousIndex = polygon.length - 1;

    polygon.forEach(function (current, currentIndex) {
      var previous = polygon[previousIndex];
      var crosses = ((current.y > point.y) !== (previous.y > point.y)) &&
        (point.x < ((previous.x - current.x) * (point.y - current.y) / (previous.y - current.y)) + current.x);

      if (crosses) inside = !inside;
      previousIndex = currentIndex;
    });

    return inside;
  }

  function boxesOverlap(first, second) {
    return first.minX < second.maxX && first.maxX > second.minX && first.minY < second.maxY && first.maxY > second.minY;
  }

  function setTextLines(text, lines, centerX, centerY, lineGapAfter) {
    var groupGap = 0.3;
    var gapCount = Array.isArray(lineGapAfter) ? lineGapAfter.length : 0;
    var totalLineSpacing = ((lines.length - 1) * 1.16) + (gapCount * groupGap);

    text.replaceChildren();
    text.setAttribute('x', centerX);
    text.setAttribute('y', centerY);

    lines.forEach(function (line, lineIndex) {
      var tspan = document.createElementNS(SVG_NAMESPACE, 'tspan');
      var followsGroupGap = lineIndex > 0 && lineGapAfter && lineGapAfter.indexOf(lineIndex - 1) !== -1;

      tspan.setAttribute('x', centerX);
      tspan.setAttribute('dy', lineIndex === 0 ? (-totalLineSpacing / 2) + 'em' : (1.16 + (followsGroupGap ? groupGap : 0)) + 'em');
      tspan.textContent = line;
      text.appendChild(tspan);
    });
  }

  function createBoothLabels(svg, rectanglesByBooth, boothIndex) {
    var labelGroup = document.createElementNS(SVG_NAMESPACE, 'g');
    var fittingProblems = [];

    labelGroup.setAttribute('class', 'flair-map-labels');
    labelGroup.setAttribute('data-map-labels', '');
    labelGroup.setAttribute('aria-hidden', 'true');
    labelGroup.style.pointerEvents = 'none';
    svg.appendChild(labelGroup);

    Object.keys(rectanglesByBooth).forEach(function (boothNumber) {
      var rectangle = rectanglesByBooth[boothNumber];
      var booth = boothIndex[boothNumber];
      var override = MAP_LABEL_OVERRIDES[boothNumber] || {};
      var geometry = rectangleGeometry(rectangle);
      var numberElement = svg.querySelector('text[data-booth-number="' + boothNumber + '"]');
      var numberBounds = numberElement ? elementBounds(numberElement) : null;
      var width = geometry.maxX - geometry.minX;
      var height = geometry.maxY - geometry.minY;
      var padding = Math.max(6, Math.min(width, height) * 0.07);
      var area = {
        minX: geometry.minX + padding,
        maxX: geometry.maxX - padding,
        minY: geometry.minY + padding,
        maxY: geometry.maxY - padding
      };
      var centerY = (geometry.minY + geometry.maxY) / 2;
      var usableWidth;
      var usableHeight;
      var proportionalCap;
      var candidates;
      var bestFit = null;
      var text = document.createElementNS(SVG_NAMESPACE, 'text');

      if (numberBounds) {
        if (((numberBounds.minY + numberBounds.maxY) / 2) >= centerY) {
          area.maxY = Math.min(area.maxY, numberBounds.minY - (padding * 0.5));
        } else {
          area.minY = Math.max(area.minY, numberBounds.maxY + (padding * 0.5));
        }
      }

      if (area.maxY - area.minY < MIN_LABEL_FONT_SIZE * 1.3) {
        area.minY = geometry.minY + padding;
        area.maxY = geometry.maxY - padding;
      }

      usableWidth = area.maxX - area.minX;
      usableHeight = area.maxY - area.minY;
      proportionalCap = Math.min(
        MAX_LABEL_FONT_SIZE,
        Math.max(24, Math.sqrt(usableWidth * usableHeight) * 0.26 * (override.fontSizeMultiplier || 1))
      );
      candidates = override.displayLines ? [override.displayLines.slice()] : measuredLineCandidates(booth.mapLabel, 3);

      text.setAttribute('class', 'flair-floor-map__exhibitor-label');
      text.setAttribute('data-map-label', boothNumber);
      text.setAttribute('text-anchor', 'middle');
      text.setAttribute('dominant-baseline', 'middle');
      text.setAttribute('visibility', 'hidden');
      if (override.rotation) {
        text.setAttribute('transform', 'rotate(' + override.rotation + ' ' + ((area.minX + area.maxX) / 2) + ' ' + ((area.minY + area.maxY) / 2) + ')');
      }
      labelGroup.appendChild(text);

      candidates.forEach(function (candidateLines) {
        var trialFontSize = Math.floor(proportionalCap);
        var candidateFit = null;

        while (trialFontSize >= MIN_LABEL_FONT_SIZE && !candidateFit) {
          var textBox;
          var measuredWidths;
          var bounds;
          var fits;

          setTextLines(text, candidateLines, (area.minX + area.maxX) / 2, (area.minY + area.maxY) / 2, override.lineGapAfter);
          text.style.fontSize = trialFontSize + 'px';
          measuredWidths = Array.prototype.map.call(text.querySelectorAll('tspan'), function (line) {
            return line.getComputedTextLength();
          });
          textBox = text.getBBox();
          bounds = {
            minX: textBox.x,
            maxX: textBox.x + textBox.width,
            minY: textBox.y,
            maxY: textBox.y + textBox.height
          };
          fits = measuredWidths.every(function (lineWidth) { return lineWidth <= usableWidth; }) &&
            bounds.minX >= area.minX && bounds.maxX <= area.maxX &&
            bounds.minY >= area.minY && bounds.maxY <= area.maxY &&
            (!numberBounds || !boxesOverlap(bounds, numberBounds));
          if (fits) {
            fits = [
              { x: bounds.minX, y: bounds.minY },
              { x: bounds.maxX, y: bounds.minY },
              { x: bounds.maxX, y: bounds.maxY },
              { x: bounds.minX, y: bounds.maxY }
            ].every(function (point) { return pointInsidePolygon(point, geometry.points); });
          }
          if (fits) {
            var awkwardBreak = candidateLines.some(function (line) {
              return /^(?:[+&]|by\b)/i.test(line);
            });
            candidateFit = {
              lines: candidateLines,
              fontSize: trialFontSize,
              score: trialFontSize - ((candidateLines.length - 1) * 4) - (awkwardBreak ? 12 : 0) - ((Math.max.apply(null, measuredWidths) - Math.min.apply(null, measuredWidths)) / Math.max.apply(null, measuredWidths) * 2)
            };
          } else {
            trialFontSize -= 1;
          }
        }

        if (candidateFit && (!bestFit || candidateFit.score > bestFit.score)) bestFit = candidateFit;
      });

      if (bestFit) {
        setTextLines(text, bestFit.lines, (area.minX + area.maxX) / 2, (area.minY + area.maxY) / 2, override.lineGapAfter);
        text.style.fontSize = bestFit.fontSize + 'px';
      } else {
        setTextLines(text, override.displayLines || wordsToLines(booth.mapLabel, 8, 3), (area.minX + area.maxX) / 2, (area.minY + area.maxY) / 2, override.lineGapAfter);
        text.style.fontSize = MIN_LABEL_FONT_SIZE + 'px';
      }
      text.setAttribute('data-label-fits', bestFit ? 'true' : 'false');
      text.setAttribute('data-label-rotation', String(override.rotation || 0));
      text.setAttribute('data-label-area-width', usableWidth.toFixed(2));
      text.setAttribute('data-label-area-height', usableHeight.toFixed(2));
      text.setAttribute('data-label-font-cap', proportionalCap.toFixed(2));
      if (!bestFit) fittingProblems.push(boothNumber);
    });

    return {
      group: labelGroup,
      fittingProblems: fittingProblems
    };
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>'"]/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[character];
    });
  }

  function safeExternalUrl(value, type) {
    var cleaned = cleanString(value);

    if (!cleaned) return '';
    if (type === 'instagram' && !/^https?:\/\//i.test(cleaned)) {
      cleaned = 'https://www.instagram.com/' + cleaned.replace(/^@/, '').replace(/^\/+|\/+$/g, '');
    } else if (!/^https?:\/\//i.test(cleaned)) {
      cleaned = 'https://' + cleaned.replace(/^\/+/, '');
    }

    return /^https?:\/\//i.test(cleaned) ? cleaned : '';
  }

  function recordLinks(record) {
    var website = safeExternalUrl(record.website, 'website');
    var instagram = safeExternalUrl(record.instagram, 'instagram');
    var links = [];

    if (website) links.push('<a href="' + escapeHtml(website) + '" target="_blank" rel="noopener noreferrer">Website<span class="visually-hidden"> for ' + escapeHtml(record.name) + ' (opens in a new tab)</span></a>');
    if (instagram) links.push('<a href="' + escapeHtml(instagram) + '" target="_blank" rel="noopener noreferrer">Instagram<span class="visually-hidden"> for ' + escapeHtml(record.name) + ' (opens in a new tab)</span></a>');
    return links.length ? '<span class="flair-floor-map__record-links">' + links.join(' ') + '</span>' : '';
  }

  function recordsList(records) {
    if (!records.length) return '';
    return '<ul class="flair-floor-map__record-list">' + records.map(function (record) {
      return '<li><span>' + escapeHtml(record.name) + '</span>' + recordLinks(record) + '</li>';
    }).join('') + '</ul>';
  }

  function representedBrandsList(records, listKey) {
    var listId = 'FlairFloorMapRepresentedBrands-' + listKey;
    var html = '<ul class="flair-floor-map__record-list" id="' + listId + '" data-represented-list>';

    html += records.map(function (record, index) {
      return '<li' + (index >= 5 ? ' data-represented-extra hidden' : '') + '><span>' + escapeHtml(record.name) + '</span>' + recordLinks(record) + '</li>';
    }).join('');
    html += '</ul>';

    if (records.length > 5) {
      html += '<button class="flair-floor-map__represented-toggle" type="button" aria-controls="' + listId + '" aria-expanded="false" data-represented-toggle data-represented-total="' + records.length + '">Show all ' + records.length + ' lines</button>';
    }

    return html;
  }

  function recordTypeLabel(record) {
    if (!record) return '';
    if (record.recordType === 'showroom') return 'Showroom';
    if (record.recordType === 'brand') return 'Brand';
    if (record.recordType === 'represented_brand') return 'Represented line';
    return '';
  }

  function groupedShowrooms(booth) {
    return booth.showrooms.slice().sort(function (first, second) {
      if (first === booth.primary) return -1;
      if (second === booth.primary) return 1;
      return compareByName(first, second);
    }).map(function (showroom) {
      return {
        showroom: showroom,
        representedBrands: booth.representedBrands.filter(function (record) {
          return record.parentShowroom === showroom;
        })
      };
    });
  }

  function multipleShowroomRelationships(booth) {
    var groups = groupedShowrooms(booth);
    var html = '<section class="flair-floor-map__relationships"><h3>Brands and Lines Represented</h3>';

    groups.forEach(function (group, index) {
      html += '<div class="flair-floor-map__relationship-group flair-floor-map__showroom-group">';
      html += '<h4>' + escapeHtml(group.showroom.name) + '</h4>';
      html += recordLinks(group.showroom);
      if (group.representedBrands.length) {
        html += '<h5>Lines Represented</h5>';
        html += representedBrandsList(group.representedBrands, booth.booth + '-showroom-' + index);
      }
      html += '</div>';
    });

    if (booth.directBrands.length) {
      html += '<div class="flair-floor-map__relationship-group"><h4>Brands at This Booth</h4>' + recordsList(booth.directBrands) + '</div>';
    }
    html += '</section>';
    return html;
  }

  function renderDetails(body, booth) {
    var directRecords = booth.showrooms.concat(booth.directBrands).sort(compareByName);
    var colocatedRecords = directRecords.filter(function (record) { return record !== booth.primary; });
    var primaryType = recordTypeLabel(booth.primary);
    var hasRelationshipDetails = colocatedRecords.length > 0 || booth.representedBrands.length > 0;
    var hasMultipleShowrooms = booth.showrooms.length > 1;
    var primaryLinks = booth.primary && !hasMultipleShowrooms ? recordLinks(booth.primary) : '';
    var html = '<div class="flair-floor-map__details-summary"><p class="flair-floor-map__booth-number">Booth ' + escapeHtml(booth.booth) + '</p>';

    if (primaryType) html += '<p class="flair-floor-map__record-type">' + escapeHtml(primaryType) + '</p>';
    html += '</div>';
    if (primaryLinks) html += '<div class="flair-floor-map__primary-links">' + primaryLinks + '</div>';

    if (hasMultipleShowrooms) {
      html += multipleShowroomRelationships(booth);
    } else if (hasRelationshipDetails) {
      html += '<section class="flair-floor-map__relationships"><h3>Brands and Lines Represented</h3>';
      if (colocatedRecords.length) {
        html += '<div class="flair-floor-map__relationship-group"><h4>Brands at This Booth</h4>' + recordsList(colocatedRecords) + '</div>';
      }
      if (booth.representedBrands.length) {
        html += '<div class="flair-floor-map__relationship-group"><h4>Lines Represented</h4>' + representedBrandsList(booth.representedBrands, booth.booth) + '</div>';
      }
      html += '</section>';
    }
    if (booth.categories.length) {
      html += '<section><h3>Categories</h3><ul class="flair-floor-map__category-list">' + booth.categories.map(function (category) {
        return '<li>' + escapeHtml(category) + '</li>';
      }).join('') + '</ul></section>';
    }
    html += '<p class="flair-floor-map__directory-link"><a href="' + DIRECTORY_PAGE_URL + '">Browse Full Directory</a></p>';
    body.innerHTML = html;
  }

  function requestedMapState() {
    var url;
    var hashMatch;

    try {
      url = new URL(window.location.href);
      hashMatch = url.hash.match(/^#booth-(\d+)$/i);
      return {
        booth: cleanString(url.searchParams.get('booth')) || (hashMatch ? hashMatch[1] : ''),
        category: cleanString(url.searchParams.get('category'))
      };
    } catch (error) {
      return { booth: '', category: '' };
    }
  }

  function replaceMapParameter(name, value) {
    var url;

    if (!window.history || !window.history.replaceState) return;

    try {
      url = new URL(window.location.href);
      if (value) url.searchParams.set(name, value);
      else url.searchParams.delete(name);
      if (name === 'booth' && /^#booth-\d+$/i.test(url.hash)) url.hash = '';
      window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
    } catch (error) {
      console.warn('[FLAIR floor map] URL state could not be updated.');
    }
  }

  function initializeMap(section, svg, directoryState) {
    var status = section.querySelector('[data-map-status]');
    var filters = section.querySelector('[data-map-filters]');
    var filterList = section.querySelector('[data-map-filter-list]');
    var filterCount = section.querySelector('[data-map-filter-count]');
    var zoomInButton = section.querySelector('[data-map-zoom-in]');
    var zoomOutButton = section.querySelector('[data-map-zoom-out]');
    var fitButton = section.querySelector('[data-map-fit]');
    var details = section.querySelector('[data-map-details]');
    var detailsTitle = section.querySelector('[data-map-details-title]');
    var detailsBody = section.querySelector('[data-map-details-body]');
    var detailsClose = section.querySelector('[data-map-details-close]');
    var titleId = 'FlairFloorMapTitle-' + Math.random().toString(36).slice(2);
    var title = document.createElementNS(SVG_NAMESPACE, 'title');
    var matchResult;
    var boothCount;
    var viewport;
    var labelResult;
    var labelGroup;
    var boothContentBounds;
    var viewBox;
    var contentBounds;
    var scale = 1;
    var fitScale = 1;
    var maxScale = 1;
    var translateX = 0;
    var translateY = 0;
    var fitTranslateX = 0;
    var fitTranslateY = 0;
    var touchPointers = {};
    var touchDrag = null;
    var mouseDrag = null;
    var pinchStart = null;
    var suppressClickUntil = 0;
    var lastSelectedBooth = null;
    var fittingProblems;
    var activeCategory = '';
    var initialState = requestedMapState();
    var initialMapScrollComplete = false;
    var selectedPositionFrame = null;
    var resizeTimer = null;

    title.id = titleId;
    title.textContent = 'Interactive FLAIR floor map';
    svg.insertBefore(title, svg.firstChild);
    svg.classList.add('flair-floor-map__svg');
    svg.setAttribute('role', 'group');
    svg.setAttribute('aria-labelledby', titleId);
    svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
    svg.removeAttribute('width');
    svg.removeAttribute('height');

    matchResult = matchBooths(svg);
    boothCount = matchResult.count;
    viewport = createViewport(svg);
    boothContentBounds = combinedBoothBounds(matchResult.rectanglesByBooth);
    viewBox = setEffectiveViewBox(svg, boothContentBounds);

    Object.keys(matchResult.rectanglesByBooth).forEach(function (boothNumber) {
      var rectangle = matchResult.rectanglesByBooth[boothNumber];
      var booth = directoryState.booths[boothNumber];

      if (!booth || !booth.primary) {
        throw new Error('No directory primary label was found for SVG booth ' + boothNumber + '.');
      }
      rectangle.setAttribute('aria-label', booth.primary.name + ', booth ' + boothNumber);
    });

    Object.keys(directoryState.booths).forEach(function (boothNumber) {
      if (!matchResult.rectanglesByBooth[boothNumber]) {
        throw new Error('Directory booth ' + boothNumber + ' has no matching SVG rectangle.');
      }
    });

    labelResult = createBoothLabels(svg, matchResult.rectanglesByBooth, directoryState.booths);
    labelGroup = labelResult.group;
    fittingProblems = labelResult.fittingProblems;

    zoomInButton.setAttribute('aria-label', 'Zoom in floor map');
    zoomOutButton.setAttribute('aria-label', 'Zoom out floor map');
    fitButton.setAttribute('aria-label', 'Fit full floor map');

    function categoryFromValue(value) {
      var normalized = cleanString(value).toLocaleLowerCase();

      if (!normalized) return '';
      return directoryState.categories.filter(function (category) {
        return category.toLocaleLowerCase() === normalized;
      })[0] || '';
    }

    function renderCategoryFilters() {
      var categories = [''].concat(directoryState.categories);

      if (!filters || !filterList || !filterCount) return;
      filterList.replaceChildren();
      categories.forEach(function (category) {
        var button = document.createElement('button');

        button.className = 'flair-floor-map__filter';
        button.type = 'button';
        button.textContent = category || 'All';
        button.setAttribute('data-map-category', category);
        button.setAttribute('aria-pressed', category ? 'false' : 'true');
        filterList.appendChild(button);
      });
      filters.hidden = false;
    }

    function scrollCategoryIntoView(button, smooth) {
      window.setTimeout(function () {
        var listBounds;
        var buttonBounds;
        var targetLeft;
        var maximumLeft;

        if (!filterList || !button || filterList.scrollWidth <= filterList.clientWidth) return;
        listBounds = filterList.getBoundingClientRect();
        buttonBounds = button.getBoundingClientRect();
        if (button === filterList.firstElementChild) {
          targetLeft = 0;
        } else if (buttonBounds.left >= listBounds.left && buttonBounds.right <= listBounds.right) {
          return;
        } else {
          targetLeft = button.offsetLeft - ((filterList.clientWidth - button.offsetWidth) / 2);
          maximumLeft = filterList.scrollWidth - filterList.clientWidth;
          targetLeft = Math.min(maximumLeft, Math.max(0, targetLeft));
        }
        if (filterList.scrollTo) {
          filterList.scrollTo({ left: targetLeft, behavior: smooth ? 'smooth' : 'auto' });
        } else {
          filterList.scrollLeft = targetLeft;
        }
      }, 0);
    }

    function applyCategoryFilter(requestedCategory, options) {
      var exactCategory = categoryFromValue(requestedCategory);
      var matchingBooths;
      var matchCount;
      var activeButton = null;

      options = options || {};
      if (requestedCategory && !exactCategory && options.warnInvalid !== false) {
        console.warn('[FLAIR floor map] Unknown category ignored: ' + requestedCategory);
      }
      activeCategory = exactCategory;
      matchingBooths = activeCategory ? directoryState.categoryBooths[activeCategory] : Object.keys(directoryState.booths);
      matchCount = matchingBooths.length;
      section.classList.toggle('is-category-filtered', Boolean(activeCategory));
      section.setAttribute('data-active-category', activeCategory);

      Array.prototype.forEach.call(filterList ? filterList.querySelectorAll('[data-map-category]') : [], function (button) {
        var pressed = button.getAttribute('data-map-category') === activeCategory;

        button.setAttribute('aria-pressed', pressed ? 'true' : 'false');
        if (pressed) activeButton = button;
      });
      if (activeButton && options.scroll !== false) scrollCategoryIntoView(activeButton, options.animateScroll !== false);

      Object.keys(matchResult.rectanglesByBooth).forEach(function (boothNumber) {
        var rectangle = matchResult.rectanglesByBooth[boothNumber];
        var booth = directoryState.booths[boothNumber];
        var numberLabel = svg.querySelector('[data-booth-number="' + boothNumber + '"]');
        var exhibitorLabel = labelGroup.querySelector('[data-map-label="' + boothNumber + '"]');
        var matches = !activeCategory || matchingBooths.indexOf(boothNumber) !== -1;
        var accessibleLabel = booth.primary.name + ', booth ' + boothNumber;

        [rectangle, numberLabel, exhibitorLabel].forEach(function (element) {
          if (!element) return;
          element.classList.toggle('is-category-match', Boolean(activeCategory) && matches);
          element.classList.toggle('is-category-muted', Boolean(activeCategory) && !matches);
        });
        if (activeCategory && matches) accessibleLabel += ', matches ' + activeCategory;
        rectangle.setAttribute('aria-label', accessibleLabel);
      });

      if (filterCount) filterCount.textContent = matchCount + (matchCount === 1 ? ' booth' : ' booths');
      if (options.announce !== false) {
        status.textContent = activeCategory
          ? activeCategory + ': ' + matchCount + (matchCount === 1 ? ' booth highlighted.' : ' booths highlighted.')
          : 'All ' + matchCount + ' booths shown.';
      }
      if (options.updateUrl !== false) replaceMapParameter('category', activeCategory);
    }

    renderCategoryFilters();

    function isAtFit() {
      return scale <= fitScale + SCALE_EPSILON;
    }

    function labelVisibilityThreshold() {
      if (window.innerWidth < 750) return LABEL_VISIBILITY_THRESHOLDS.mobile;
      if (window.innerWidth < 990) return LABEL_VISIBILITY_THRESHOLDS.tablet;
      return LABEL_VISIBILITY_THRESHOLDS.desktop;
    }

    function syncLabelVisibility() {
      var baseThreshold = labelVisibilityThreshold();

      Array.prototype.forEach.call(labelGroup.querySelectorAll('[data-map-label]'), function (label) {
        var boothNumber = label.getAttribute('data-map-label');
        var rectangle = matchResult.rectanglesByBooth[boothNumber];
        var matrix = label.getScreenCTM();
        var rectangleBounds = rectangle.getBoundingClientRect();
        var fontSize = parseFloat(label.style.fontSize) || 0;
        var renderedFontSize = matrix ? fontSize * Math.hypot(matrix.a, matrix.b) : 0;
        var minimumWidth = window.innerWidth < 750 ? 15 : window.innerWidth < 990 ? 20 : 24;
        var minimumHeight = window.innerWidth < 750 ? 10 : window.innerWidth < 990 ? 12 : 14;
        var threshold = baseThreshold;
        var selected = rectangle && rectangle.classList.contains('is-selected');
        var boothCanCarryLabel;
        var visible;

        if (rectangleBounds.width >= 60 && rectangleBounds.height >= 30) threshold -= 0.75;
        else if (rectangleBounds.width < 32 || rectangleBounds.height < 16) threshold += window.innerWidth < 750 ? 0.5 : 0.75;
        boothCanCarryLabel = rectangleBounds.width >= minimumWidth && rectangleBounds.height >= minimumHeight;
        visible = label.getAttribute('data-label-fits') === 'true' && (selected || (boothCanCarryLabel && renderedFontSize >= threshold));

        label.setAttribute('visibility', visible ? 'visible' : 'hidden');
        label.setAttribute('data-label-visible', visible ? 'true' : 'false');
        label.setAttribute('data-rendered-font-size', renderedFontSize.toFixed(2));
        label.setAttribute('data-rendered-booth-width', rectangleBounds.width.toFixed(2));
        label.setAttribute('data-rendered-booth-height', rectangleBounds.height.toFixed(2));
        label.setAttribute('data-label-threshold', threshold.toFixed(2));
      });
    }

    function syncControls() {
      zoomOutButton.disabled = isAtFit();
      zoomInButton.disabled = scale >= maxScale - SCALE_EPSILON;
      svg.classList.toggle('can-pan', !isAtFit());
      syncLabelVisibility();
    }

    function applyTransform() {
      var transform = 'translate(' + translateX + ' ' + translateY + ') scale(' + scale + ')';

      viewport.setAttribute('transform', transform);
      labelGroup.setAttribute('transform', transform);
      syncControls();
    }

    function clampScale(value) {
      return Math.min(maxScale, Math.max(fitScale, value));
    }

    function clampPan() {
      var contentWidth;
      var contentHeight;
      var minimumVisibleX;
      var minimumVisibleY;
      var minimumTranslateX;
      var maximumTranslateX;
      var minimumTranslateY;
      var maximumTranslateY;

      if (isAtFit()) {
        scale = fitScale;
        translateX = fitTranslateX;
        translateY = fitTranslateY;
        return;
      }

      contentWidth = contentBounds.width * scale;
      contentHeight = contentBounds.height * scale;
      minimumVisibleX = Math.min(viewBox.width * 0.15, contentWidth * 0.2);
      minimumVisibleY = Math.min(viewBox.height * 0.15, contentHeight * 0.2);

      if (contentWidth <= viewBox.width) {
        translateX = viewBox.x + ((viewBox.width - contentWidth) / 2) - (contentBounds.x * scale);
      } else {
        minimumTranslateX = viewBox.x + minimumVisibleX - ((contentBounds.x + contentBounds.width) * scale);
        maximumTranslateX = viewBox.x + viewBox.width - minimumVisibleX - (contentBounds.x * scale);
        translateX = Math.min(maximumTranslateX, Math.max(minimumTranslateX, translateX));
      }

      if (contentHeight <= viewBox.height) {
        translateY = viewBox.y + ((viewBox.height - contentHeight) / 2) - (contentBounds.y * scale);
      } else {
        minimumTranslateY = viewBox.y + minimumVisibleY - ((contentBounds.y + contentBounds.height) * scale);
        maximumTranslateY = viewBox.y + viewBox.height - minimumVisibleY - (contentBounds.y * scale);
        translateY = Math.min(maximumTranslateY, Math.max(minimumTranslateY, translateY));
      }
    }

    function zoomAt(nextScale, focalX, focalY) {
      var clampedScale = clampScale(nextScale);
      var ratio;

      if (Math.abs(clampedScale - scale) <= SCALE_EPSILON) {
        syncControls();
        return;
      }

      ratio = clampedScale / scale;
      translateX = focalX - ((focalX - translateX) * ratio);
      translateY = focalY - ((focalY - translateY) * ratio);
      scale = clampedScale;
      clampPan();
      applyTransform();
    }

    function clientToViewBox(clientX, clientY) {
      var point = svg.createSVGPoint();
      var matrix = svg.getScreenCTM();

      point.x = clientX;
      point.y = clientY;

      return matrix ? point.matrixTransform(matrix.inverse()) : point;
    }

    function fitMap() {
      viewport.removeAttribute('transform');
      labelGroup.removeAttribute('transform');
      viewBox = setEffectiveViewBox(svg, boothContentBounds);
      contentBounds = boothContentBounds;
      fitScale = 1;
      maxScale = fitScale * MAX_ZOOM_MULTIPLIER;
      fitTranslateX = 0;
      fitTranslateY = 0;
      scale = fitScale;
      translateX = fitTranslateX;
      translateY = fitTranslateY;
      mouseDrag = null;
      pinchStart = null;
      touchDrag = null;
      svg.classList.remove('is-dragging');
      applyTransform();
    }

    function viewBoxCenter() {
      return {
        x: viewBox.x + (viewBox.width / 2),
        y: viewBox.y + (viewBox.height / 2)
      };
    }

    function positionSelectedBooth(rectangle) {
      var svgBounds = svg.getBoundingClientRect();
      var boothBounds = rectangle.getBoundingClientRect();
      var detailsBounds = details.getBoundingClientRect();
      var siteHeader = document.querySelector('sticky-header, .header-wrapper');
      var siteHeaderBounds = siteHeader ? siteHeader.getBoundingClientRect() : null;
      var smallDrawer = window.innerWidth < 990;
      var margin = 16;
      var visibleLeft = Math.max(svgBounds.left, 0) + margin;
      var visibleRight = Math.min(svgBounds.right, window.innerWidth) - margin;
      var visibleTop = Math.max(svgBounds.top, siteHeaderBounds && siteHeaderBounds.top <= 0 ? siteHeaderBounds.bottom : 0) + margin;
      var visibleBottom = Math.min(svgBounds.bottom, smallDrawer ? detailsBounds.top : window.innerHeight) - margin;
      var desiredX;
      var desiredY;
      var boothCenterX;
      var boothCenterY;
      var focalPoint;
      var deltaX;
      var deltaY;
      var unitsPerPixelX;
      var unitsPerPixelY;

      if (visibleBottom <= visibleTop || visibleRight <= visibleLeft) return;

      if (!smallDrawer) {
        deltaX = boothBounds.left < visibleLeft
          ? visibleLeft - boothBounds.left
          : boothBounds.right > visibleRight ? visibleRight - boothBounds.right : 0;
        deltaY = boothBounds.top < visibleTop
          ? visibleTop - boothBounds.top
          : boothBounds.bottom > visibleBottom ? visibleBottom - boothBounds.bottom : 0;
        if ((!deltaX && !deltaY) || isAtFit()) return;
        unitsPerPixelX = viewBox.width / svgBounds.width;
        unitsPerPixelY = viewBox.height / svgBounds.height;
        translateX += deltaX * unitsPerPixelX;
        translateY += deltaY * unitsPerPixelY;
        clampPan();
        applyTransform();
        return;
      }

      desiredX = (visibleLeft + visibleRight) / 2;
      desiredY = (visibleTop + visibleBottom) / 2;
      boothCenterX = (boothBounds.left + boothBounds.right) / 2;
      boothCenterY = (boothBounds.top + boothBounds.bottom) / 2;

      if (isAtFit()) {
        focalPoint = clientToViewBox(boothCenterX, boothCenterY);
        zoomAt(Math.min(maxScale, fitScale * 1.2), focalPoint.x, focalPoint.y);
        svgBounds = svg.getBoundingClientRect();
        boothBounds = rectangle.getBoundingClientRect();
        boothCenterX = (boothBounds.left + boothBounds.right) / 2;
        boothCenterY = (boothBounds.top + boothBounds.bottom) / 2;
      }

      deltaX = desiredX - boothCenterX;
      deltaY = desiredY - boothCenterY;
      if (Math.abs(deltaX) < 1 && Math.abs(deltaY) < 1) return;
      unitsPerPixelX = viewBox.width / svgBounds.width;
      unitsPerPixelY = viewBox.height / svgBounds.height;
      translateX += deltaX * unitsPerPixelX;
      translateY += deltaY * unitsPerPixelY;
      clampPan();
      applyTransform();
    }

    function scheduleSelectedBoothPosition() {
      var selectedRectangle = svg.querySelector('rect[data-booth].is-selected');

      if (!selectedRectangle || details.hidden) return;
      if (selectedPositionFrame) window.cancelAnimationFrame(selectedPositionFrame);
      selectedPositionFrame = window.requestAnimationFrame(function () {
        selectedPositionFrame = window.requestAnimationFrame(function () {
          selectedPositionFrame = null;
          positionSelectedBooth(selectedRectangle);
        });
      });
    }

    function visibleHeaderHeight() {
      var siteHeader = document.querySelector('sticky-header, .header-wrapper');
      var bounds = siteHeader ? siteHeader.getBoundingClientRect() : null;

      return bounds && bounds.top <= 0 && bounds.bottom > 0 ? bounds.bottom : 0;
    }

    function scrollToMapOnce() {
      var target = filters && !filters.hidden ? filters : section.querySelector('[data-map-frame]');
      var targetBounds;
      var targetTop;
      var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (initialMapScrollComplete || !target || window.Shopify && window.Shopify.designMode) return;
      initialMapScrollComplete = true;
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          targetBounds = target.getBoundingClientRect();
          targetTop = Math.max(0, window.pageYOffset + targetBounds.top - visibleHeaderHeight() - 12);
          window.scrollTo({ top: targetTop, behavior: reducedMotion ? 'auto' : 'smooth' });
          scheduleSelectedBoothPosition();
          if (!reducedMotion) window.setTimeout(scheduleSelectedBoothPosition, 500);
        });
      });
    }

    function clearBoothSelection() {
      var selectedRectangle = svg.querySelector('rect[data-booth].is-selected');
      var boothNumber;
      var numberLabel;
      var exhibitorLabel;

      if (!selectedRectangle) return null;
      boothNumber = selectedRectangle.getAttribute('data-booth');
      numberLabel = svg.querySelector('[data-booth-number="' + boothNumber + '"]');
      exhibitorLabel = labelGroup.querySelector('[data-map-label="' + boothNumber + '"]');
      selectedRectangle.classList.remove('is-selected');
      selectedRectangle.setAttribute('aria-pressed', 'false');
      if (numberLabel) numberLabel.classList.remove('is-selected-booth');
      if (exhibitorLabel) exhibitorLabel.classList.remove('is-selected-booth');
      return selectedRectangle;
    }

    function closeDetails(restoreFocus, updateUrl) {
      var focusTarget;

      if (details.hidden) return;
      focusTarget = clearBoothSelection() || lastSelectedBooth;
      details.hidden = true;
      details.setAttribute('aria-hidden', 'true');
      section.classList.remove('is-details-open');
      if (updateUrl !== false) replaceMapParameter('booth', '');
      status.textContent = activeCategory
        ? activeCategory + ' category filter remains active. Booth details closed.'
        : 'Booth details closed.';
      window.requestAnimationFrame(syncLabelVisibility);
      if (restoreFocus && focusTarget) focusTarget.focus();
    }

    function openDetails(booth, rectangle) {
      lastSelectedBooth = rectangle;
      detailsTitle.textContent = booth.primary.name;
      renderDetails(detailsBody, booth);
      detailsBody.scrollTop = 0;
      details.hidden = false;
      details.setAttribute('aria-hidden', 'false');
      section.classList.add('is-details-open');
      window.requestAnimationFrame(function () {
        try {
          detailsTitle.focus({ preventScroll: true });
        } catch (error) {
          detailsTitle.focus();
        }
        syncLabelVisibility();
        scheduleSelectedBoothPosition();
      });
    }

    function selectBooth(rectangle, options) {
      var boothNumber = rectangle.getAttribute('data-booth');
      var booth = directoryState.booths[boothNumber];
      var previousSelection = svg.querySelector('rect[data-booth].is-selected');

      options = options || {};

      if (previousSelection && previousSelection !== rectangle) {
        var previousBoothNumber = previousSelection.getAttribute('data-booth');
        var previousNumberLabel = svg.querySelector('[data-booth-number="' + previousBoothNumber + '"]');
        var previousExhibitorLabel = labelGroup.querySelector('[data-map-label="' + previousBoothNumber + '"]');

        previousSelection.classList.remove('is-selected');
        previousSelection.setAttribute('aria-pressed', 'false');
        if (previousNumberLabel) previousNumberLabel.classList.remove('is-selected-booth');
        if (previousExhibitorLabel) previousExhibitorLabel.classList.remove('is-selected-booth');
      }

      rectangle.classList.add('is-selected');
      rectangle.setAttribute('aria-pressed', 'true');
      svg.querySelector('[data-booth-number="' + boothNumber + '"]').classList.add('is-selected-booth');
      labelGroup.querySelector('[data-map-label="' + boothNumber + '"]').classList.add('is-selected-booth');
      syncLabelVisibility();
      status.textContent = booth.primary.name + ', booth ' + boothNumber + ' selected. Details opened.';
      if (options.updateUrl !== false) replaceMapParameter('booth', boothNumber);
      openDetails(booth, rectangle);
    }

    function touchValues() {
      return Object.keys(touchPointers).map(function (pointerId) {
        return touchPointers[pointerId];
      });
    }

    function pinchDistance(first, second) {
      return Math.hypot(second.clientX - first.clientX, second.clientY - first.clientY);
    }

    function pinchMidpoint(first, second) {
      return {
        clientX: (first.clientX + second.clientX) / 2,
        clientY: (first.clientY + second.clientY) / 2
      };
    }

    svg.addEventListener('click', function (event) {
      var rectangle = event.target.closest('rect[data-booth]');

      if (Date.now() < suppressClickUntil) return;

      if (rectangle) selectBooth(rectangle);
    });

    svg.addEventListener('keydown', function (event) {
      var rectangle = event.target.closest('rect[data-booth]');

      if (!rectangle || (event.key !== 'Enter' && event.key !== ' ')) return;

      event.preventDefault();
      selectBooth(rectangle);
    });

    svg.addEventListener('pointerdown', function (event) {
      var values;
      var midpoint;
      var focalPoint;

      if (event.pointerType === 'touch') {
        touchPointers[event.pointerId] = {
          pointerId: event.pointerId,
          clientX: event.clientX,
          clientY: event.clientY
        };
        values = touchValues();

        if (values.length === 2) {
          touchDrag = null;
          midpoint = pinchMidpoint(values[0], values[1]);
          focalPoint = clientToViewBox(midpoint.clientX, midpoint.clientY);
          pinchStart = {
            distance: Math.max(1, pinchDistance(values[0], values[1])),
            scale: scale,
            anchorX: (focalPoint.x - translateX) / scale,
            anchorY: (focalPoint.y - translateY) / scale
          };
          suppressClickUntil = Date.now() + 400;
          values.forEach(function (pointer) {
            if (!svg.hasPointerCapture(pointer.pointerId)) svg.setPointerCapture(pointer.pointerId);
          });
          event.preventDefault();
        } else if (values.length === 1 && !isAtFit()) {
          svg.setPointerCapture(event.pointerId);
          touchDrag = {
            pointerId: event.pointerId,
            clientX: event.clientX,
            clientY: event.clientY,
            translateX: translateX,
            translateY: translateY,
            moved: false
          };
          svg.classList.add('is-dragging');
        }
        return;
      }

      if (event.pointerType !== 'mouse' || event.button !== 0 || isAtFit()) return;

      svg.setPointerCapture(event.pointerId);
      mouseDrag = {
        pointerId: event.pointerId,
        clientX: event.clientX,
        clientY: event.clientY,
        translateX: translateX,
        translateY: translateY,
        rectangle: event.target.closest('rect[data-booth]'),
        moved: false
      };
      svg.classList.add('is-dragging');
    });

    svg.addEventListener('pointermove', function (event) {
      var values;
      var midpoint;
      var focalPoint;
      var nextScale;
      var viewBoxUnitsPerPixelX;
      var viewBoxUnitsPerPixelY;

      if (event.pointerType === 'touch') {
        if (!touchPointers[event.pointerId]) return;

        touchPointers[event.pointerId].clientX = event.clientX;
        touchPointers[event.pointerId].clientY = event.clientY;
        values = touchValues();

        if (values.length === 1 && touchDrag && event.pointerId === touchDrag.pointerId) {
          event.preventDefault();
          viewBoxUnitsPerPixelX = viewBox.width / svg.getBoundingClientRect().width;
          viewBoxUnitsPerPixelY = viewBox.height / svg.getBoundingClientRect().height;
          if (Math.hypot(event.clientX - touchDrag.clientX, event.clientY - touchDrag.clientY) > 5) {
            touchDrag.moved = true;
            suppressClickUntil = Date.now() + 400;
          }
          translateX = touchDrag.translateX + ((event.clientX - touchDrag.clientX) * viewBoxUnitsPerPixelX);
          translateY = touchDrag.translateY + ((event.clientY - touchDrag.clientY) * viewBoxUnitsPerPixelY);
          clampPan();
          applyTransform();
          return;
        }

        if (values.length !== 2 || !pinchStart) return;

        event.preventDefault();
        midpoint = pinchMidpoint(values[0], values[1]);
        focalPoint = clientToViewBox(midpoint.clientX, midpoint.clientY);
        nextScale = clampScale(pinchStart.scale * (pinchDistance(values[0], values[1]) / pinchStart.distance));
        scale = nextScale;
        translateX = focalPoint.x - (pinchStart.anchorX * scale);
        translateY = focalPoint.y - (pinchStart.anchorY * scale);
        suppressClickUntil = Date.now() + 400;
        clampPan();
        applyTransform();
        return;
      }

      if (!mouseDrag || event.pointerId !== mouseDrag.pointerId) return;

      viewBoxUnitsPerPixelX = viewBox.width / svg.getBoundingClientRect().width;
      viewBoxUnitsPerPixelY = viewBox.height / svg.getBoundingClientRect().height;

      if (Math.hypot(event.clientX - mouseDrag.clientX, event.clientY - mouseDrag.clientY) > 5) {
        mouseDrag.moved = true;
        suppressClickUntil = Date.now() + 300;
      }

      translateX = mouseDrag.translateX + ((event.clientX - mouseDrag.clientX) * viewBoxUnitsPerPixelX);
      translateY = mouseDrag.translateY + ((event.clientY - mouseDrag.clientY) * viewBoxUnitsPerPixelY);
      clampPan();
      applyTransform();
    });

    function endPointer(event) {
      var tappedRectangle;

      if (event.pointerType === 'touch') {
        delete touchPointers[event.pointerId];

        if (svg.hasPointerCapture(event.pointerId)) svg.releasePointerCapture(event.pointerId);
        if (touchDrag && touchDrag.pointerId === event.pointerId) touchDrag = null;
        if (touchValues().length < 2) {
          pinchStart = null;
          touchDrag = null;
          svg.classList.remove('is-dragging');
        }
        return;
      }

      if (!mouseDrag || event.pointerId !== mouseDrag.pointerId) return;

      tappedRectangle = !mouseDrag.moved ? mouseDrag.rectangle : null;

      if (svg.hasPointerCapture(event.pointerId)) {
        svg.releasePointerCapture(event.pointerId);
      }

      mouseDrag = null;
      svg.classList.remove('is-dragging');

      if (tappedRectangle) {
        suppressClickUntil = Date.now() + 300;
        selectBooth(tappedRectangle);
      }
    }

    svg.addEventListener('pointerup', endPointer);
    svg.addEventListener('pointercancel', endPointer);

    zoomInButton.addEventListener('click', function () {
      var center = viewBoxCenter();
      zoomAt(scale * ZOOM_STEP, center.x, center.y);
    });

    zoomOutButton.addEventListener('click', function () {
      var center = viewBoxCenter();
      zoomAt(scale / ZOOM_STEP, center.x, center.y);
    });

    fitButton.addEventListener('click', fitMap);
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        if (isAtFit()) fitMap();
        else syncLabelVisibility();
        scheduleSelectedBoothPosition();
      }, 150);
    });
    if (window.ResizeObserver) {
      new ResizeObserver(function () { scheduleSelectedBoothPosition(); }).observe(details);
    }
    if (filterList) {
      filterList.addEventListener('click', function (event) {
        var button = event.target.closest('[data-map-category]');

        if (!button) return;
        applyCategoryFilter(button.getAttribute('data-map-category'), { animateScroll: true });
        syncLabelVisibility();
      });
    }
    detailsClose.addEventListener('click', function () { closeDetails(true); });
    detailsBody.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-represented-toggle]');
      var expanded;

      if (!toggle) return;
      expanded = toggle.getAttribute('aria-expanded') === 'true';
      var controlledList = document.getElementById(toggle.getAttribute('aria-controls'));

      if (!controlledList || !detailsBody.contains(controlledList)) return;
      Array.prototype.forEach.call(controlledList.querySelectorAll('[data-represented-extra]'), function (item) {
        item.hidden = expanded;
      });
      toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      toggle.textContent = expanded ? 'Show all ' + toggle.getAttribute('data-represented-total') + ' lines' : 'Show fewer lines';
    });
    section.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !details.hidden) {
        event.preventDefault();
        closeDetails(true);
      }
    });

    fitMap();
    applyCategoryFilter(initialState.category, { updateUrl: false, announce: false, animateScroll: false });
    status.textContent = boothCount + ' interactive booths and ' + directoryState.records.length + ' directory records loaded.';
    if (directoryState.ambiguousBooths.length) {
      console.warn('[FLAIR floor map] Temporary ambiguous primary labels:', directoryState.ambiguousBooths.map(function (booth) {
        return booth.booth + ': ' + booth.primary.name + ' (' + booth.ambiguityReason + ')';
      }));
    }
    if (fittingProblems.length) console.warn('[FLAIR floor map] Labels at minimum font size:', fittingProblems);
    if (initialState.booth) {
      if (matchResult.rectanglesByBooth[initialState.booth]) {
        selectBooth(matchResult.rectanglesByBooth[initialState.booth], { updateUrl: false });
      } else {
        console.warn('[FLAIR floor map] Unknown booth ignored: ' + initialState.booth);
      }
    }
    scrollToMapOnce();
  }

  function loadMap(section) {
    var canvas = section.querySelector('[data-map-canvas]');
    var status = section.querySelector('[data-map-status]');
    var svgUrl = section.getAttribute('data-map-svg-url');
    var directoryUrl = section.getAttribute('data-directory-json-url');

    if (!canvas || !svgUrl || !directoryUrl || !window.fetch || !window.DOMParser) return;

    Promise.all([
      fetch(svgUrl, { credentials: 'same-origin' }).then(function (response) {
        if (!response.ok) throw new Error('Floor map request failed with status ' + response.status + '.');
        return response.text();
      }),
      fetch(directoryUrl, { credentials: 'same-origin' }).then(function (response) {
        if (!response.ok) throw new Error('Directory data request failed with status ' + response.status + '.');
        return response.json();
      })
    ])
      .then(function (results) {
        var svgText = results[0];
        var rawRecords = results[1];
        var parsedDocument = new DOMParser().parseFromString(svgText, 'image/svg+xml');
        var parsedSvg = parsedDocument.documentElement;
        var normalizedRecords;
        var directoryState;
        var svg;

        if (!parsedSvg || parsedSvg.tagName.toLowerCase() !== 'svg' || parsedDocument.querySelector('parsererror')) {
          throw new Error('Floor map asset is not valid SVG.');
        }
        if (!Array.isArray(rawRecords)) throw new Error('Directory data asset must contain an array of records.');

        normalizedRecords = rawRecords.map(normalizeRecord);
        directoryState = buildBoothIndex(normalizedRecords);
        if (directoryState.unresolvedRepresented.length) {
          throw new Error(directoryState.unresolvedRepresented.length + ' represented brand relationships could not be resolved.');
        }

        svg = document.importNode(parsedSvg, true);
        canvas.replaceChildren(svg);
        initializeMap(section, svg, directoryState);
      })
      .catch(function (error) {
        canvas.innerHTML = '<p class="flair-floor-map__error" role="alert">The floor map could not be loaded.</p>';
        status.textContent = 'The floor map could not be loaded.';
        console.error('[FLAIR floor map]', error);
      });
  }

  document.querySelectorAll('[data-flair-floor-map]').forEach(loadMap);
})();
